import React from 'react';
import HarbourIcon from './HarbourIcon';
import { formatDateCovered } from '../../utils/referralUploads';
import './harbour.css';
import './harbourDocuments.css';

/*
 * Harbour/Document row (Figma 4345:4647): a document the SENCO or a parent
 * or carer added to the referral. File mark, the document type as the title,
 * the date it covers and the file name muted, then their own description.
 * Remove sits at the right on desktop and under the text on a phone, with a
 * 44px tap area, and only while the referral has not been sent.
 *
 * View is not built: the service-user side has no way to open a file yet
 * (rmsFetchReferralDocument serves providers only).
 */
export default function HarbourDocumentRow({ document, layout = 'desktop', onRemove }) {
  const doc = document || {};
  const title = doc.documentTypeLabel || 'Document';
  const meta = [formatDateCovered(doc.dateCovered), doc.originalFilename].filter(Boolean).join(' · ');
  const canRemove = Boolean(doc.canRemove && onRemove);
  return (
    <li className={`harbour-doc-row harbour-doc-row--${layout}`}>
      <span className="harbour-doc-row__mark">
        <HarbourIcon name="file-pdf" size={32} />
      </span>
      <div className="harbour-doc-row__text">
        <p className="harbour-doc-row__title">{title}</p>
        {meta && <p className="harbour-doc-row__meta">{meta}</p>}
        {doc.description && <p className="harbour-doc-row__description">{doc.description}</p>}
      </div>
      {canRemove && (
        <div className="harbour-doc-row__actions">
          <button
            type="button"
            className="harbour-text-link harbour-doc-row__action"
            aria-label={`Remove ${doc.description || title}`}
            onClick={() => onRemove(doc)}
          >
            Remove
          </button>
        </div>
      )}
    </li>
  );
}
